import { wget } from 'lodash';

function getReferralStatusEnums(state) {
  return wget(state, 'session.enums.referrals.dashboard_statuses', []);
}

export default getReferralStatusEnums;
